import { animate, style, transition, trigger } from '@angular/animations';
import { Component, HostBinding, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

@Component({
  animations: [
    trigger('parentAnimation', [
      transition(':enter', [style({ opacity: 0 }), animate('0.2s', style({ opacity: 0.7 }))]),
      transition(':leave', [animate('0.2s', style({ opacity: 0 }))]),
    ]),
    trigger('childAnimation', [
      transition(':enter', [
        style({ transform: 'translateY(-25px)' }),
        animate('0.2s ease', style({ transform: 'translateY(0)' })),
      ]),
      transition(':leave', [animate('0.2s ease', style({ transform: 'translateY(-25px)' }))]),
    ]),
  ],
  selector: 'portal-loading-indicator',
  templateUrl: './loading-indicator.component.html',
  styleUrls: ['./loading-indicator.component.scss'],
  standalone: false,
})
export class LoadingIndicatorComponent implements OnChanges, OnInit {
  @HostBinding('class')
  className: string;

  @Input()
  fixed: boolean = false;

  @Input()
  show: boolean = false;

  @Input()
  indicatorStyle: 'opaque' | 'transparent' = 'transparent';

  public _show: boolean = false;

  private showTimeout?: any;

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if ('show' in changes) {
      const currentValue = changes.show.currentValue;

      if (this.showTimeout !== undefined) {
        clearTimeout(this.showTimeout);

        this.showTimeout = undefined;
      }

      if (currentValue === true) {
        // Show the loading indicator only if the loading takes longer than 100ms
        this.showTimeout = setTimeout(() => {
          this._show = currentValue;
        }, 100);
      } else {
        this._show = currentValue;
      }
    }
  }

  ngOnInit() {}
}
